var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHugeiconsBloodPressure(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 53,
    viewBox: "0 0 54 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4884 28.7135H22.2546C23.6456 28.7135 24.3411 28.7135 24.8996 29.0447C25.4604 29.3737 25.7717 29.9676 26.3921 31.1554L29.7415 37.5449L34.3669 24.2979L37.714 30.6874C38.3366 31.8752 38.6457 32.4691 39.2065 32.8003C39.7651 33.1292 40.4605 33.1292 41.8515 33.1292H44.7747",
    stroke: "white",
    strokeWidth: 3.31177,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8786 26.5059C44.183 18.5908 37.5418 11.1371 32.6845 6.57348C31.2359 5.19653 29.3136 4.42871 27.315 4.42871C25.3164 4.42871 23.3942 5.19653 21.9455 6.57348C16.3376 11.8458 8.34521 20.973 8.34521 30.2107C8.34521 39.2673 15.5295 48.5844 27.315 48.5844C34.8062 48.5844 40.4385 44.8222 43.5471 39.753",
    stroke: "white",
    strokeWidth: 3.31177,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHugeiconsBloodPressure);
export default __webpack_public_path__ + "static/media/hugeicons_blood-pressure.3f17d9f5516bbe32a24d82e2691c3233.svg";
export { ForwardRef as ReactComponent };